import { Component, Input } from '@angular/core';

@Component({
  selector: 'era-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  @Input() isDetail = false;
}
